module.exports = __webpack_public_path__ + "static/media/favico.c11e3556.ico";